export interface SessionView {
  orderId: string;
  itemName: string;
  size: string;
  amount: number;
  /**
   * 'awaiting_confirmation': the buyer has tapped Pay. Their payment is
   * recorded, expiresAt is null, and there is no countdown to render.
   */
  status: 'open' | 'expired' | 'sold' | 'awaiting_confirmation';
  expiresAt: number | null;
}

export interface ShippingPayload {
  name: string;
  phone: string;
  cityRef: string;
  cityName: string;
  warehouseRef: string;
  warehouseName: string;
}

function baseUrl(): string {
  const url = process.env.REACT_APP_BOT_API_URL;
  if (!url) throw new Error('REACT_APP_BOT_API_URL is not configured');
  return url.replace(/\/$/, '');
}

async function request<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(`${baseUrl()}${path}`, {
    headers: { 'content-type': 'application/json' },
    ...init,
  });
  const body = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error((body as { error?: string }).error ?? `HTTP ${res.status}`);
  return body as T;
}

export function fetchSession(orderId: string): Promise<SessionView> {
  return request<SessionView>(`/api/session/${orderId}`);
}

export function submitShipping(orderId: string, s: ShippingPayload): Promise<{ payUrl: string }> {
  return request<{ payUrl: string }>(`/api/session/${orderId}/shipping`, {
    method: 'POST',
    body: JSON.stringify(s),
  });
}

/**
 * Fire-and-forget: this starts the proof timers, but a failure here must never
 * stop the buyer reaching the payment page. Worst case the seller is not
 * nudged and the reservation expires normally.
 */
export async function notifyPaymentInitiated(orderId: string): Promise<void> {
  try {
    await request<{ ok: true }>(`/api/session/${orderId}/payment-initiated`, { method: 'POST' });
  } catch (err) {
    console.warn('payment-initiated ping failed', err);
  }
}
